module.exports = __webpack_public_path__ + "static/media/lafourchette-2.4f52ffb6.png";